
    <div class="d-flex flex-column">
        <div class="d-flex flex-column rating-item">
            <div class="d-flex flex-row w-100 pointer">
                <label class="flex-grow-1 pointer"
                    (click)="onOpenNotes()">
                  {{label}} <span class="text-danger ms-1" *ngIf="config.isRequired">*</span>
                </label>
                <ngx-stars
                    [wholeStars]="true"
                    [initialStars]="config.initialValue"
                    [customPadding]="'0.9rem'"
                    [customSize]="'1.7rem'"
                    [color]="'#FF9500'"
                    (ratingOutput)="onRatingSet($event)">
                </ngx-stars>
            </div>
          <mat-form-field appearance="outline" *ngIf="isOpenNotes" style="margin-bottom: -1.25em">
            <textarea
                #notesEl
                [required]="ratingGiven < 4"
                matInput
                [placeholder]="placeholder"
                rows="2"
                [(ngModel)]="otherValueSet"
                (ngModelChange)="onNotesChange($event)"
                (blur)="onBlur()"
                [value]="config.initialOtherValue"
                maxlength="300">
            </textarea>
          </mat-form-field>
            <div *ngIf="!isOpenNotes && otherValueSet" (click)="onOpenNotes()"
                class="d-flex flex-row align-items-center pb-3">
                <div class="text-1-line text-comment">{{ otherValueSet }}</div>
                <mat-icon class="ms-1 pointer"  style="min-width: 24px">keyboard_arrow_down</mat-icon>
            </div>
        </div>
    </div>
